import {
  Colors,
  IconBulkOperations,
  IconChat,
  IconDashboard,
  IconDispute,
  IconDocument,
  IconInventory,
  IconReports,
  IconSearchBig,
  IconSwitch,
  MenuListItem,
} from "@bounce/shared/ui";
import NiceModal from "@ebay/nice-modal-react";
import React from "react";
import ContactUsDialog from "../pages/contact-us/ContactUsDialog";
import {urls} from "../routes/urls";

export const getMenuItems = (
  disputesAlert?: boolean,
  displaySwitchUser?: boolean,
  documentRequestsAlert?: boolean,
  isFpPartner?: boolean,
  isPartnerLoading?: boolean,
  isMultiPartner?: boolean
): MenuListItem[] => {
  const showTpItems = !isPartnerLoading && !isFpPartner;

  return [
    {
      id: "dashboard",
      type: "category-item",
      title: "Dashboards",
      icon: <IconDashboard color={Colors.secondary._400} size={20} />,
      url: urls.dashboard.url,
      display: true,
    },
    {
      id: "search",
      type: "category-item",
      title: "Search",
      icon: <IconSearchBig color={Colors.secondary._400} width={20} height={20} />,
      url: urls.search.url,
      display: true,
    },
    {
      id: "bulk-operations",
      type: "category-nest-item",
      title: "bulk operations",
      icon: <IconBulkOperations color={Colors.secondary._400} size={20} />,
      subListItems: [
        {id: "import-direct-payments", title: "Import direct payments", url: urls.importDirectPayments.url},
        {id: "import-recalls", title: "Import recalls", url: urls.importRecalls.url},
        {id: "place-accounts", title: "Place accounts", url: urls.placeAccounts.url},
      ],
      display: showTpItems,
    },
    {
      id: "inventory",
      type: "category-item",
      title: "Inventory",
      icon: <IconInventory color={Colors.secondary._400} width={20} height={20} />,
      url: urls.inventory.url,
      display: true,
    },
    {
      id: "reports",
      type: "category-item",
      title: "Reports",
      icon: <IconReports color={Colors.secondary._400} size={20} />,
      url: urls.reports.url,
      display: true,
    },
    {
      id: "disputes",
      type: "category-item",
      title: "Disputes",
      icon: <IconDispute color={Colors.secondary._400} width={20} height={20} />,
      url: urls.disputes.url,
      alert: disputesAlert,
      display: showTpItems,
    },
    {
      id: "document-requests",
      type: "category-item",
      title: "Document requests",
      icon: <IconDocument color={Colors.secondary._400} size={20} />,
      url: urls.documentRequests.url,
      alert: documentRequestsAlert,
      display: showTpItems,
    },
    {
      id: "contact_us",
      type: "category-item",
      title: "Contact us",
      icon: <IconChat color={Colors.secondary._400} width={20} height={20} />,
      onClick: () => {
        NiceModal.show(ContactUsDialog);
      },
      display: true,
    },
    {
      id: "partner-selector",
      type: "category-item",
      title: "Switch partner",
      icon: <IconSwitch color={Colors.secondary._400} width={20} height={20} />,
      url: urls.partnerSelector.url,
      display: displaySwitchUser && !isMultiPartner,
    },
  ];
};
